<template>
    <div class="index">
      <div class="container">
        <div class="swiper-box">
          <el-carousel height="600px" :interval="2000" arrow="always" class="swiper-container" >
            <el-carousel-item v-for="item in slideList" :key="item.id" class="item-swiper" >
              <a>
                <img v-bind:src="item.img" @click="skipto(item.path)"/>
              </a>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- <div class="company">
          <div class="item-company">
            <div class="company-value-title"><i></i>为什么学棋<i></i></div>
          </div>
          <div class="company-value">
            <div class="item-cons">
              <div class="cons-img">
                <img src="../assets/index/happy.png" />
              </div>
              <div class="cons-title">意想不到的快乐</div>
              <div class="cons-content">棋类的竞技游戏属性，</div>
              <div class="cons-content">天然的吸引孩子产生兴趣，</div>
              <div class="cons-content">在玩乐中提升思维</div>
            </div>
            <div class="item-cons">
              <div class="cons-img">
                <img src="../assets/index/chengzhang.png" />
              </div>
              <div class="cons-title">意想不到的成长</div>
              <div class="cons-content">增强思维</div>
              <div class="cons-content">提升格局</div>
              <div class="cons-content">培养心智</div>
            </div>
            <div class="item-cons">
              <div class="cons-img">
                <img src="../assets/index/red.png" />
              </div>
              <div class="cons-title">意想不到的红利</div>
              <div class="cons-content">目前全国已有97所高校对棋类特长生提供了升学加分，保送政策，而严重的信息不对称，让棋类赛道的竞争相对更小！</div>
            </div>
          </div>
        </div>
        <div class="why-choose-xixiaoxiang">
          <div class="item-choose-xixiaoxiang">
            <div class="choose-xixiaoxiang-title"><i></i>为什么要选择弈小象<i></i></div>
          </div>
          <div class="choose-xixiaoxiang">
            <div class="choose-xixiaoxiang-cons" v-for="(item,index) in chessImg" :key='index'>
              <div :class="index!=1? 'xixiaoxiang-img' :'xixiaoxiang-cons'">
                <img :src="item.url"/>
              </div>
              <div :class="index!=1? 'xixiaoxiang-cons' :'xixiaoxiang-img'">
                <img :src="item.img"/>
              </div>
            </div>
          </div>
        </div>
        <div class="teacher-teams">
          <div class="item-teacher-teams">
            <div class="teacher-teams-title"><i></i>师资团队<i></i></div>
          </div>
          <div class="teacher-cons">
            <div class="item-teacher-cons">
              <div class="teacher-imgs" v-for="(item,index) in teacherList" :key="index">
                <div class="imgs-cons">
                  <img :src="item.img" />
                  <div class="bottom-imgs">
                    <p>{{item.name}}</p>
                  </div>
                </div>
                <div class="teacher-contents">
                  <div class="contens-box">
                    <div class="contens-title">{{item.name}}</div>
                    <div class="contens-border"></div>
                    <div class="contens-cons" v-for="(item,index) in item.introduce" :key="index">
                      <p>{{item.one}}</p>
                      <p>{{item.two}}</p>
                      <p>{{item.three}}</p>
                      <p>{{item.four}}</p>
                      <p>{{item.five}}</p>
                      <p>{{item.six}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="partner-teams">
          <div class="item-partner-teams">
            <div class="partner-teams-title"><i></i>合作伙伴<i></i></div>
          </div>
          <div class="item-partner"> -->
<!--            <div class="par-pho" style="width: 463px;">-->
<!--              <img src="../assets/partner/bama.png">-->
<!--            </div>-->
<!--            <div class="par-pho" style="width: 272px;">-->
<!--              <img src="../assets/partner/aha.png">-->
<!--            </div>-->
<!--            <div class="par-pho" style="width: 307px;">-->
<!--              <img src="../assets/partner/xiang.png">-->
<!--            </div>-->
<!--            <div class="par-pho" style="width: 524px;">-->
<!--              <img src="../assets/partner/xiao.png">-->
<!--            </div>-->
<!--            <div class="par-pho" style="width: 227px;">-->
<!--              <img src="../assets/partner/chang.png">-->
<!--            </div>-->
<!--            <div class="par-pho" style="width: 155px;">-->
<!--              <img src="../assets/partner/ta.png">-->
<!--            </div>-->
<!--            <div class="par-pho" style="width: 330px;">-->
<!--              <img src="../assets/partner/mama.png">-->
<!--            </div>-->
<!--            <div class="par-pho" style="width: 360px;">-->
<!--              <img src="../assets/partner/xin.png" width="360px;">-->
<!--            </div>-->
<!--            <div class="par-pho" style="width: 277px;">-->
<!--              <img src="../assets/partner/zhang.png">-->
<!--            </div>-->
          <!-- </div>
        </div> -->
      </div>
    </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      chessImg: [
        {
          url: require('../assets/index/zgxq.png'),
          img: require('../assets/imgs/q1.png')
        },
        {
          img: require('../assets/index/wq.png'),
          url: require('../assets/imgs/q2.png')
        },
        {
          url: require('../assets/index/gx.png'),
          img: require('../assets/imgs/q3.png')
        }
      ],
      teacherList: [
        {
          img: require('../assets/teacher/l.png'),
          name: '弈小象创始人&CEO：兰宇',
          introduce: [
            {one: '弈小象创始人&CEO'},
            {two: '国家棋协大师'},
            {three: '南开大学管理学学士，阿德莱德大学金融学硕士'},
            {four: '2008年全国象棋比赛前三甲（并因此被保送至南开大学）'}
          ]
        },
        {
          img: require('../assets/teacher/ym.png'),
          name: '教学团队:  弈鸣老师',
          introduce: [
            {one: '弈小象联合创始人'},
            {two: '首席测评官'},
            {three: '资深棋类教练、裁判员'},
            {four: '选拔培养多名少儿冠军'}
          ]
        },
        {
          img: require('../assets/teacher/ss.png'),
          name: '教学团队:  宋宋老师',
          introduce: [
            {one: '国家等级运动员'},
            {two: '地方棋协大师'},
            {three: '担任北京红庙象棋课老师、北京人大附中象棋课老师'},
            {four: '2016年 全国威凯一级运动员象棋比赛前十名'},
            {five: '2016年 全国象棋青年赛前十名'},
            {six: '2018、19年 全国等级赛前八名'}
          ]
        },
        {
          img: require('../assets/teacher/c.png'),
          name: '教学团队: 崔航',
          introduce: [
            {one: '清华大学本科及硕士'},
            {two: '国际棋联大师'},
            {three: '多次获得两项棋类盛世冠军'},
            {four: '曾任清华大学中国象棋队队长'},
            {five: '荣获世界象棋联合会授予的国际棋联大师称号'}
          ]
        },
        {
          img: require('../assets/teacher/yy.png'),
          name: '教学团队:  玉思源',
          introduce: [
            {one: '中国象棋运动员'},
            {two: '象棋国家级裁判'},
            {three: '毕业于南开大学'},
            {four: '2009年 全国象棋一级棋士赛女子组冠军'},
            {five: '2010年 晋升为国家象棋大师'},
            {six: '2017年 全国象棋团体赛女子冠军'}
          ]
        },
        {
          img: require('../assets/teacher/dw.png'),
          name: '教学团队:  李大卫',
          introduce: [
            {one: '国际象棋棋协大师'},
            {two: '国际象棋课程体系搭建师'},
            {three: '曾任人大附中 国家少年队队员'},
            {four: '北京市青少儿国际象棋赛冠军'},
            {five: '10年+教学经验'},
            {six: '曾担任人大附中、史家小学等名校国际象棋课程教师'}
          ]
        }
      ],
      slideList: [
        // {
        //   id: '24',
        //   path: '/',
        //   img: require('../assets/swiper/index1.jpg')
        // },
        // {
        //   id: '25',
        //   path: '/',
        //   img: require('../assets/swiper/index2.jpg')
        // },
        {
          id: '26',
          path: '/',
          img: require('../assets/swiper/index3.jpg')
        }
      ],
      show: false,
      status: false
    }
  },
  created () {
    this.status = this.$route.query.status
  },
  methods: {
    skipto (path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/base.scss";
  @import "../assets/scss/mixin.scss";
  @import "../assets/scss/config.scss";
  .el-carousel__container {
    height: 600px!important;
  }
  .index{
    width: 100%;
    @media only screen and (min-width: 540px) and (max-width: 1180px){
      width: 1180px;
    }
    .container {
      width: 100%;
      .swiper-box{
        height: 600px;
        .swiper-container{
          width: 100%;
          height: 600px;
          .item-swiper {
            width: 100%;
            height: 600px;
          }
        }
        .el-carousel__item h3 {
          color: #475669;
          font-size: 18px;
          opacity: 0.75;
          line-height: 600px;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: #99a9bf;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: #d3dce6;
        }
        a{
          img{
            width: 100%;
            height: 600px;
          }
        }
      }
      .company{
        width: 1180px;
        text-align: center;
        margin: auto;
        margin-top: 60px;
        .item-company {
          width: 100%;
          margin-bottom: 35px;
          .company-value-title{
            color:$colorB;
            font-size: $fontB;
            font-weight: bold;
            // @include bgImg(306px,40px,'../assets/imgs/xian.png');
          }
        }
        .company-value {
          width: 1180px;
          display: flex;
          justify-content: space-between;
          .item-cons{
            flex: 1;
            .cons-title{
              font-size: $fontE;
              color: $colorB;
              margin-top: 18px;
              margin-bottom: 16px;
            }
            .cons-img{
              width: 356px;
              height: 250px;
              margin: auto;
              img{
                width: 100%;
                height: 100%;
              }
            }
            .cons-content{
              width: 280px;
              margin: auto;
              text-align: center;
              font-size: $fontJ;
              color: $colorC;
              // text-align: left;
            }
          }
        }
      }
      .why-choose-xixiaoxiang {
        width: 1180px;
        text-align: center;
        margin: auto;
        margin-top: 60px;
        .item-choose-xixiaoxiang {
          width: 100%;
          margin-bottom: 35px;
          .choose-xixiaoxiang-title {
            color:$colorB;
            font-size: $fontB;
            font-weight: bold;
            // @include bgImg(460px,40px,'../assets/imgs/xian.png');
          }
        }
        .choose-xixiaoxiang {
          width: 1180px;
          @include flexed();
          .choose-xixiaoxiang-cons {
            width: 100%;
            height: 320px;
            @include flex();
            margin-bottom: 20px;
            @media only screen and (min-width: 540px) and (max-width: 1180px){
              padding: 0 20px;
            }
            .xixiaoxiang-img {
              img{
                width: 554px;
                height: 320px;
              }
            }
            .xixiaoxiang-cons {
              img{
                width: 585px;
                height: 320px;
              }
            }
          }
        }
      }
      .teacher-teams{
        width: 1180px;
        text-align: center;
        margin: auto;
        margin-top: 40px;
        .item-teacher-teams {
          width: 100%;
          margin-bottom: 35px;
          .teacher-teams-title {
            color:$colorB;
            font-size: $fontB;
            font-weight: bold;
            // @include bgImg(230px,40px,'../assets/imgs/xian.png');
          }
        }
        .teacher-cons {
          width: 1180px;
          @include flexed();
          .item-teacher-cons {
            width: 100%;
            // height: 390px;
            display: flex;
            // justify-content: space-evenly;
            @include centerflexed();
            .teacher-imgs {
              margin: 18px;
              position: relative;
              &:last-child {
                margin-right: 0;
              }
              &:hover .teacher-contents{
                opacity: 0.8;    //opacity从0变成1，从透明到不透明
              }
              &:hover .imgs-cons .bottom-imgs{
                opacity: 0;    //opacity从0变成1，从透明到不透明
              }
              &:hover .imgs-cons .bottom-imgs p{
                opacity: 0;    //opacity从0变成1，从透明到不透明
              }
              .imgs-cons{
                width: 356px;
                height: 390px;
                img{
                  width: 100%;
                  height: 100%;
                  position: relative;
                }
                .bottom-imgs {
                  width: 356px;
                  height: 88px;
                  background-color: #7da6e6;
                  border-radius: 0 0 20px 20px;
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  opacity: 0.9;
                  @include bgImg(356px, 88px,'../assets/teacher/teacher_bottom.png');
                  p{
                    width: 100%;
                    height: 40px;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    line-height: 40px;
                    text-align: center;
                    color: $colorG;
                    font-size: $fontI;
                    opacity: 0.9;
                  }
                }
              }
            }
            .teacher-contents{
              width: 356px;
              height: 390px;
              background:rgba(74, 206, 255, 1);
              border-radius: 20px;
              opacity:0;
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              text-align: center;
              -webkit-backface-visibility: hidden;//隐藏旋转元素的背面
              backface-visibility: hidden;
              -webkit-transition: all 0.35s ease-in-out;   //ease-in-out设置提示信息以慢速度开始和结束的过渡效果
              -moz-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;//加浏览器的私有前缀是考虑到兼容性问题
              z-index: 111;
              .contens-box{
                width: 356px;
                height: 390px;
                padding-top: 99px;
                padding-left: 40px;
                padding-right: 40px;
                box-sizing: border-box;
                text-align: left;
                .contens-title {
                  width: 100%;
                  text-align: left;
                  font-size:16px;
                  font-family:Microsoft YaHei;
                  font-weight:bold;
                  color:rgba(255,255,255,1);
                  line-height:40px;
                }
                .contens-border{
                  width:52px;
                  height:2px;
                  background:rgba(255,255,255,1);
                }
                .contens-cons {
                  width: 100%;
                  font-size:14px;
                  font-family:Microsoft YaHei;
                  font-weight:400;
                  color:rgba(255,255,255,1);
                  line-height:18px;
                  letter-spacing: 2px;
                  margin-top: 5px;
                }
              }
            }
            .teacher-content{
              display: inline-block;
            }
          }
        }

      }
      .partner-teams {
        width: 1180px;
        text-align: center;
        margin: auto;
        margin-top: 40px;
        .item-partner-teams {
          width: 100%;
          margin-bottom: 35px;
          .partner-teams-title {
            color: $colorB;
            font-size: $fontB;
            font-weight: bold;
            // @include bgImg(230px, 40px, '../assets/imgs/xian.png');
          }
        }
        .item-partner {
          width: 100%;
          margin-top: 30px;
          @include bgImg(1180px,472px,'../assets/imgs/icon.png');
          margin-bottom: 100px;
          @include flexed();
          .par-pho {
            margin-bottom: 20px;
          }
        }
      }
      .value-icon {
        width: 1000px;
        margin: auto;
        display: flex;
        justify-content: space-between;
        padding-left: 100px;
        padding-right: 100px;
        margin-top: 80px;
        margin-bottom: 80px;
        img{
          width: 153px;
          height: 144px;
        }
      }
      .about-us {
        width: 100%;
        height: 600px;
      }
      .team{
        width: 100%;
        .teamcons {
          width: 1226px;
          margin: auto;
          @include flex();
          .item-teamcons {
            margin-top: 80px;
            width: 100%;
            @include flex();
            flex-direction: row;
            flex-wrap: wrap;
            margin-bottom: 80px;
            .team-pho {
              width: 600px;
              border: 2px solid #4B5692;
              border-radius: 3%;
              margin-bottom: 10px;
              img{
                width: 400px;
              }
            }
          }
        }
      }
      .partner {
        width: 1226px;
        margin: auto;
        margin-top: 80px;
        .item-partner {
          width: 100%;
          @include flex();
          flex-direction: row;
          flex-wrap: wrap;
          margin-bottom: 80px;
          .par-pho {
            width: 400px;
            img{
              width: 300px;
            }
          }
        }
      }
    }
    .company-value-title,.choose-xixiaoxiang-title,.teacher-teams-title,.partner-teams-title{
      i{
        display: inline-block;
        width: 23px;
        height: 23px;
        margin-right: 26px;
        @include bgImg(23px,23px,'../assets/imgs/san_left.png');
      }
      i:last-of-type{
        margin-left: 26px;
        @include bgImg(23px,23px,'../assets/imgs/san_right.png');
      }
    }
   .imgs-cons img{
      border-radius: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue